var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.parent && _vm.value && _vm.value.length > 0
    ? _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm._l(_vm.value, function(v, i) {
            return _c("text-group", {
              key: i,
              staticClass: "ml-20px",
              attrs: { utext: v, btext: _vm.parent[v] }
            })
          }),
          _c(
            "v-btn",
            {
              staticClass: "ml-5 btn-primary",
              attrs: { small: "" },
              on: { click: _vm.parent.log }
            },
            [_vm._v("log formControls")]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }